module.exports = __webpack_public_path__ + "static/media/icon-select.a4125b8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-select.svg
// module id = 436
// module chunks = 0